module.exports = __webpack_public_path__ + "static/media/front.1211855d.jpg";